(() => {
  const roots = document.querySelectorAll('[data-product-root]');
  roots.forEach((root) => {
    const variantsNode = root.querySelector('[data-product-variants]');
    if (!variantsNode) return;

    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch (error) { return; }

    const idInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addText = root.querySelector('[data-add-to-cart-text]');
    const consent = root.querySelector('[data-video-consent]');
    const consentInput = root.querySelector('[data-video-consent-input]');
    const currencyNode = root.querySelector('[data-currency-code]');
    const currency = currencyNode ? JSON.parse(currencyNode.textContent) : 'USD';

    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency
    }).format(cents / 100);

    const getSelectedOptions = () => {
      const positions = [...new Set([...root.querySelectorAll('[data-option-position]')].map((input) => Number(input.dataset.optionPosition)))];
      return positions.sort((a, b) => a - b).map((position) => {
        const checked = root.querySelector(`[data-option-position="${position}"]:checked`);
        return checked ? checked.value : null;
      });
    };

    const updateVariant = () => {
      const selected = getSelectedOptions();
      const variant = selected.length
        ? variants.find((item) => item.options.every((option, index) => option === selected[index]))
        : variants.find((item) => String(item.id) === String(idInput.value)) || variants[0];

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }

      idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.textContent = formatMoney(variant.compare_at_price);
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }
      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';

      const videoSelected = selected.some((rawValue) => {
        const value = String(rawValue || '').toLowerCase();
        return value.includes('tiktok') || value.includes('instagram') || (value.includes('video') && !value.includes('no video'));
      });
      if (consent) consent.hidden = !videoSelected;
      if (consentInput) {
        consentInput.required = videoSelected;
        if (!videoSelected) consentInput.checked = false;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    root.querySelectorAll('.more-sizes').forEach((details) => {
      if (details.querySelector('input:checked')) details.open = true;
    });
    root.querySelectorAll('[data-option-position]').forEach((input) => input.addEventListener('change', updateVariant));
    updateVariant();
  });
})();
